import Vue from "vue";
import url from "./apiurls";
import { store } from "../store/store";

export const teacherApi = new Vue({
  methods: {
    teacherSignUp(userData) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.signUp, userData)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    uploadResume(resume) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.uploadResume, resume)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getAllTeachers() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getAllTeachers)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTeachersByCategory(categoryId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getTeachersByCategory}${categoryId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTeacherByTeacherId(teacherId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getTeacherDetails}${teacherId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getTeacherReview(teacherId) {
      return new Promise((resolve, reject) => {
        const getUrl = `${url.getTeacherReview}/${teacherId}`;
        this.$http
          .get(getUrl)
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getFollowingStudents() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getFollowingStudents)
          .then(res => {
            store.dispatch("user/setFollowingStudents", res.data);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCourseSubscribedStudents() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.getCourseSubscribedStudents)
          .then(res => {
            store.dispatch("user/setTeacherSubscription", res.data);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
